// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"905":"e0968f1b","2449":"f86032dc","6190":"452727a4"}[chunkId] + ".chunk.css";
};